import { useEffect, useState } from "react";

interface Props {
  blob: Blob | null;
  mimeType: string;
  className?: string;
  iconClass?: string;
}

export default function DocumentThumb({ blob, mimeType, className = "", iconClass = "text-2xl" }: Props) {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!blob) {
      setUrl(null);
      return undefined;
    }
    const objectUrl = URL.createObjectURL(blob);
    setUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [blob]);

  const isImage = mimeType?.startsWith("image/");

  if (isImage && url) {
    return <img src={url} alt="" className={`object-cover ${className}`} />;
  }

  return (
    <div className={`flex items-center justify-center bg-background-200 ${className}`}>
      <i
        className={`${
          mimeType === "application/pdf" ? "ri-file-pdf-2-line" : "ri-file-text-line"
        } ${iconClass} text-foreground-400`}
      />
    </div>
  );
}